import { warn } from '@execonline-inc/logging';
import { putQueryParam, toUrlT } from '@execonline-inc/url';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import { callApi } from '../../../../../../Appy';
import ReactionComponent, { RCProps } from '../../../../../../ReactionComponent';
import { Link } from '../../../../../../Resource/Types';
import { experiencesResourceDecoder } from './Decoders';
import Store from './Store';
import { LoadError, State } from './Types';

const loadExperiences = callApi(experiencesResourceDecoder, {});

const assignSearchParameters = (store: Store) => (link: Link) => {
  return toUrlT(link.href)
    .map(
      putQueryParam(
        'product_license_id',
        store.selectedProductLicense.map((plr) => String(plr.payload.id)).getOrElseValue(''),
      ),
    )
    .map((urlParser) => ({ ...link, href: urlParser.href }));
};

class Reactions extends ReactionComponent<Store, State, RCProps<Store>> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    switch (state.kind) {
      case 'waiting':
      case 'waiting-with-link':
      case 'selecting':
      case 'showing':
      case 'hiding':
        break;
      case 'loading':
        Task.succeed<LoadError, Link>(state.link)
          .andThen(assignSearchParameters(this.props.store))
          .andThen(loadExperiences)
          .fork(this.props.store.loadingError, this.props.store.loaded);
        break;
      case 'loading-error':
        warn('Error loading Experience Catalog:', JSON.stringify(state.error));
        break;
      default:
        assertNever(state);
    }
  };
}

export default Reactions;
